var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { attrs: { "app-name": "cookbook" } },
    [
      _c("AppNavi", { staticClass: "app-navigation" }),
      _vm._v(" "),
      _c("AppContent", [
        _c("div", [_c("AppControls"), _vm._v(" "), _c("router-view")], 1),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }